// extracted by mini-css-extract-plugin
export default {"root":"Main-root-2vT"};